<template>
    <section class="">
        <!-- 1アイテム -->
        <div v-for="content in playlog_list" class="playlog_box_par">
            <div class="playlog_box">
                <div class="playlog_image_box"><img :src="content.image" alt="" class="playlog_image"></div>
                <div class="playlog_title_box" @click="jumpContentPlayer(content.destination, content.playable_status)">
                    <!-- <div class="">{{ content.type_op}}</div> -->
                    <div class="playlog_title">{{ content.title }}</div>
                    <div class="playlog_unplayable" v-show="content.playable_status==0">{{ characters.playlog_unplayable }}</div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "playlog-list",
        props: ['json_characters'],
        data: function () {
            return {
                playlog_list: [],
                characters: Object,
            }
        },
        mounted() {
            this.getPlayLogList();
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            jumpContentPlayer: function(destination, playable_status) {
                if(playable_status == 1) {
                    location.href=destination;
                }
            },
            getPlayLogList: function() {
                axios.default
                    .get('/playlog/content/get')
                    .then(response => {
                        this.playlog_list = response.data.playlog_list;
                    });
            },
        },
    }
</script>

<style scoped>
</style>
